/**
 * 年月のプルダウン(2026-09-08 発注者指示: 開始月・終了月・改定の適用開始月は年・月ともに選択式)。
 * 値は 'YYYY-MM'。allowEmpty のときは「なし」を選べる(終了月=無期限など)。
 */
type Props = {
  value: string;
  onChange: (value: string) => void;
  /** 空(未設定)を選べるようにする */
  allowEmpty?: boolean;
  emptyLabel?: string;
  /** 今年から何年前・何年先まで出すか */
  yearsBack?: number;
  yearsAhead?: number;
  disabled?: boolean;
};

export default function MonthSelect({
  value,
  onChange,
  allowEmpty = false,
  emptyLabel = 'なし',
  yearsBack = 1,
  yearsAhead = 3,
  disabled = false,
}: Props) {
  const thisYear = new Date().getFullYear();
  const [y, m] = (value ? value.split('-').map(Number) : [0, 0]) as [number, number];
  const years: number[] = [];
  for (let yy = thisYear - yearsBack; yy <= thisYear + yearsAhead; yy++) years.push(yy);
  if (y && !years.includes(y)) years.push(y);
  years.sort((a, b) => a - b);

  const emit = (year: number, month: number) => onChange(`${year}-${String(month).padStart(2, '0')}`);

  return (
    <div style={{ display: 'flex', gap: 6 }}>
      <select
        style={{ flex: 1.3, minWidth: 0 }}
        value={y || ''}
        disabled={disabled}
        onChange={(e) => {
          const year = Number(e.target.value);
          if (!year) onChange('');
          else emit(year, m || new Date().getMonth() + 1);
        }}
      >
        {(allowEmpty || !value) && <option value="">{allowEmpty ? emptyLabel : '年を選択'}</option>}
        {years.map((yy) => (
          <option key={yy} value={yy}>
            {yy}年
          </option>
        ))}
      </select>
      <select
        style={{ flex: 1, minWidth: 0 }}
        value={m || ''}
        disabled={disabled || !y}
        onChange={(e) => emit(y, Number(e.target.value))}
      >
        {!m && <option value="">月</option>}
        {Array.from({ length: 12 }, (_, i) => i + 1).map((mm) => (
          <option key={mm} value={mm}>
            {mm}月
          </option>
        ))}
      </select>
    </div>
  );
}
